'use client'

import { cx } from 'lib/cx'

export type OfferWidgetTabStates = 'myOffers' | 'updatedOffers'

type TabsProps = {
  activeTab: OfferWidgetTabStates
  onTabChange: (tab: OfferWidgetTabStates) => void
}

export default function OfferWidgetTabs({ activeTab, onTabChange }: TabsProps) {
  const tabs = [
    {
      id: 'myOffers',
      label: 'Meine Offerten',
    },
    {
      id: 'updatedOffers',
      label: 'Updates',
    },
  ]

  return (
    <div className="flex flex-row">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id as OfferWidgetTabStates)}
          className={cx(
            tab.id === activeTab
              ? 'border-border-interactive bg-gray-10 text-text-primary font-medium'
              : `bg-gray-20 text-text-secondary hover:bg-gray-hover`,
            'focus border-gray-20 border-t-0! border-b-2! bg-white px-4 pt-[calc(1rem-3px)] pb-[calc(1rem-1px)] text-sm font-normal whitespace-nowrap',
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
